import Vue from 'vue';
import store from '../store';
import Router from 'vue-router';
import axios from 'axios';
import Login from '@/pages/Login';
import MyPermit from '@/pages/MyPermit';
import MyAttachment from '@/pages/MyAttachment';
import MyApprovalList from '@/pages/MyApprovalList';
import MyAttachmentApprovalList from '@/pages/MyAttachmentApprovalList';
import NewForm from '@/pages/NewForm';
import Approval from '@/pages/Approval';
import EditForm from '@/pages/EditForm';
import UserMapping from '@/pages/UserMapping';
import NewUser from '@/pages/NewUser';
import EditUser from '@/pages/EditUser';
import Admin from '@/pages/AdminEdit';
import ListPermit from '@/pages/ListPermit';
import Pengembalian from '@/pages/Pengembalian';
import ClosingUsulan from '@/pages/ClosingUsulan';
import EditPengembalian from '@/pages/EditPengembalian';
import EditClosingUsulan from '@/pages/EditClosingUsulan';
import SubmitedVisitor from '@/pages/SubmitedVisitor';
import PreviewInduction from '@/pages/PreviewInduction';
import MyVisitor from '@/pages/MyVisitor';
import AddVisitor from '@/pages/AddVisitor';
import MenuList from '@/pages/FormMenu';
import PrintEwaskat from '@/pages/PrintEwaskat';
import EwaskatExtend from '@/pages/EwaskatExtend';
import InfoCuti from '@/pages/InfoCuti';
import Faq from '@/pages/Faq';
Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated || to.name === 'Approval Landing Page') return next();
    next('/');
}

const ifAuthenticated = (to, from, next) => {
    const parmName = {
        'user-list': 'user-list',
        'List-permit': 'List-permit',
        'admin': 'admin'
    }
    if (to.fullPath.substring(1) === parmName[to.fullPath.substring(1)] && !store.state.dataUsers.isAdmin) {
        next({ name: 'Home' })
    }
    if (!store.getters.isAuthenticated) return next('/login');
    // handle session expired
    const d = new Date();
    const config = {
        method: "get",
        url: `${store.state.API_URL}/isSessionExpired/${store.state.token}?dt=${d.getTime()}`
    };
    axios(config).then(res => {
        if (res.status == 200) {
            store.commit('setAppVersion', res.data.appVersion)
            if (res.data.expiredAt && res.data.name == 'TokenExpiredError') {
                store.dispatch('logout').then(() => {
                    return next('/logout')
                })
            } else if (res.data.name == 'JsonWebTokenError') {
                store.dispatch('logout').then(() => {
                    next('/logout')
                })
            } else {
                const allowedUserType = to.meta.allowedUserType || [];
                if ('strictMitra' in to.meta && store.getters.userLocation[0] === 'MITRA') {
                    for (const level of to.meta.strictMitra.groupLevel) {
                        if (store.getters.userGroupLevel.includes(level)) return next();
                    }
                    store.dispatch('logout').then(() => {
                        return next('/logout')
                    })
                }

                if (store.getters.userGroupLevel instanceof Array) {
                    for (const level of store.getters.userGroupLevel) {
                        if (!allowedUserType.length || allowedUserType.includes(level)) return next();
                    }
                } else {
                    if (!allowedUserType.length || allowedUserType.includes(store.getters.userGroupLevel)) return next();
                }
                store.dispatch('logout').then(() => {
                    return next('/logout')
                })
            }
        }
    }).catch((error) => {
        console.log(error);
        store.state.loader = false;
    });

}

const dispatchLogout = (to, from, next) => {
    store.dispatch('logout').then(() => {
        next()
    })
}

const routeNotExist = (to, from, next) => {
    return next('/login');
}

const approvalAllowedRoles = ['SuptDIC', 'DIC', 'PJO', 'Manager', 'PNC', 'WKTT', 'KTT', 'Mining Manager', 'Nahkoda', 'SECHEAD', 'CUSTODIAN', 'SAFETYMITRA', 'SAFETYINTERNAL', 'DIVHEAD', 'CUSTODIANDIVHEAD', 'TEAMLEADER', 'DIVHEADHSE'];

const router = new Router({
    base: '/',
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: MyPermit,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/my-attachment',
            name: 'My Attachment',
            component: MyAttachment,
            meta: { allowedUserType: ['PIC'] },
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/my-attachment-approval-list',
            name: 'My Attachment Approval List',
            component: MyAttachmentApprovalList,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: [...approvalAllowedRoles, 'PIC'] },
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Login,
            beforeEnter: dispatchLogout,
        },
        {
            path: '/user-list',
            name: 'User List',
            component: UserMapping,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/List-permit',
            name: 'List Permit',
            component: ListPermit,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/Penyelesaian-pekerjaan/:permitId/:formCode',
            name: 'Pengembalian',
            component: Pengembalian,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/Edit-penyelesaian-pekerjaan/:permitId/:formCode',
            name: 'EditPengembalian',
            component: EditPengembalian,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/closing-usulan-perubahan/:permitId/:formCode',
            name: 'ClosingUsulan',
            component: ClosingUsulan,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/edit-closing-usulan-perubahan/:permitId/:formCode',
            name: 'EditClosingUsulan',
            component: EditClosingUsulan,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/add-user',
            name: 'Add User',
            component: NewUser,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/edit-user',
            name: 'Edit User',
            component: EditUser,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/admin',
            name: 'Admin',
            component: Admin,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/my-permit',
            name: 'My Permit',
            component: MyPermit,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/menu-list',
            name: 'Create New',
            component: MenuList,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/my-visitor/:id',
            name: 'My Visitor',
            component: MyVisitor,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/add-visitor',
            name: 'Add Visitor',
            component: AddVisitor,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/my-approval-list',
            name: 'My Approval List',
            component: MyApprovalList,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: [...approvalAllowedRoles, 'WASKAT'] },
        },
        {
            path: '/add-lampiran-pengawalan',
            name: "Lampiran Izin Kerja Pengawalan Unit",
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-lampiran-pengawalan/edit/:id',
            name: 'Edit Lampiran Izin Kerja Pengawalan Unit',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-ketinggian-extend',
            name: 'Izin Kerja Di Ketinggian Extend',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-ruang-terbatas',
            name: 'Izin Kerja Masuk Ruang Terbatas',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-kerja-panas-extend',
            name: 'Izin Kerja Dengan Panas Extend',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-penggalian',
            name: 'Izin Kerja Penggalian',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-ketinggian',
            name: 'Izin Kerja Di Ketinggian',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-kelistrikan',
            name: 'Izin Kerja Bertegangan (Vicinity)',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-kelistrikan/edit/:id',
            name: 'Edit Izin Kerja Kelistrikan',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-pengawalan',
            name: 'Izin Kerja Di Pengawalan',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-tamu',
            name: 'Izin Tamu',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-kerja-dengan-panas',
            name: "Izin Kerja Dengan Panas",
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-peledakan',
            name: 'Izin Peledakan',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-izin-jangka-pendek',
            name: 'Izin Kerja Jangka Pendek',
            component: NewForm,
            // beforeEnter: ifAuthenticated,
            // meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-proyek',
            name: 'Izin Melaksanakan Kegiatan Proyek',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-jasa',
            name: 'Izin Melaksanakan Kegiatan Usaha Jasa',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/add-usulan-perubahan',
            name: 'Izin Melaksanakan Usulan Perubahan',
            component: NewForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-ketinggian/edit/:id',
            name: 'Edit Izin Kerja Di Ketinggian',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-pengawalan/edit/:id',
            name: 'Edit Izin Kerja Pengawalan',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-tamu/edit/:id',
            name: 'Edit Izin Tamu',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-ruang-terbatas/edit/:id',
            name: 'Edit Izin Kerja Ruang Terbatas',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-kerja-panas/edit/:id',
            name: 'Edit Izin Kerja Dengan Panas',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-jangka-pendek/edit/:id',
            name: 'Edit Izin Kerja Jangka Pendek',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-melaksanakan-proyek/edit/:id',
            name: 'Edit Izin Melaksanakan Kegiatan Proyek',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-usaha-jasa/edit/:id',
            name: 'Edit Izin Melaksanakan Kegiatan Usaha Jasa',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-penggalian/edit/:id',
            name: 'Edit Izin Kerja Penggalian',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-peledakan/edit/:id',
            name: 'Edit Izin Kerja Peledakan',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/ip-izin-usulan-perubahan/edit/:id',
            name: 'Edit Izin Usulan Perubahan',
            component: EditForm,
            beforeEnter: ifAuthenticated,
            meta: { allowedUserType: ['PIC'] },
        },
        {
            path: '/page-approval/:ipId/:token',
            name: 'Approval Landing Page',
            component: Approval,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/page-submited-visitor/:idVisitor/:token',
            name: 'Submit Visitor Landing Page',
            component: SubmitedVisitor,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/page-induction/:idVisitor/:token',
            name: 'Page Induction Visitor',
            component: SubmitedVisitor,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/preview-induksi/:token',
            name: 'Preview Induksi Visitor',
            component: PreviewInduction,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/print/ewaskat',
            name: 'Cetak E-Waskat',
            component: PrintEwaskat,
            beforeEnter: ifAuthenticated,
        },
        {
            path: '/ewaskat/extend',
            name: 'Perpanjangan E-Waskat',
            component: EwaskatExtend,
            beforeEnter: ifAuthenticated,
            meta: {
                strictMitra: { groupLevel: ['PIC'] }
            }
        },
        {
            path: '/info-cuti',
            name: 'Info Cuti',
            component: InfoCuti,
            beforeEnter: ifAuthenticated
        },
        {
            path: '/faq',
            name: 'Faq',
            component: Faq,
        },
        {
            path: '*',
            beforeEnter: routeNotExist
        }
    ],
});

export default router;